var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-button"},[_c('label',{staticClass:"waves-effect btn-large",attrs:{"for":"logo"}},[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"file","id":"logo","accept":"image/png, image/jpeg"},on:{"change":_vm.changeFile}}),_c('span',[_vm._v(_vm._s(_vm.error || _vm.errorInternal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }